import React, { Suspense } from 'react';
import { path } from 'ramda';

import I18n from '@core/js/components/common/I18n';

import { MarketingPreferences } from '@interlayer/js/app/components/main/MarketingPreferences/MarketingPreferences';

import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { useTranslations } from 'js/hooks/i18n';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';
import { useUserSelector } from 'js/store/hooks';

import style from './ConfirmMarketingPreferencesPopup.scss';

export const ConfirmMarketingPreferencesPopup = ({ id, onSuccess: onSuccessProp, onClose: onCloseProp }) => {
    const onClosePopup = useOnClose(id);
    const onClose = useCombinedHandler([onCloseProp, onClosePopup]);
    const t = useTranslations('playtech.mobile.system.confirmMarketingPreferencesPopup.');
    const firstName = useUserSelector(path(['userDetails', 'firstName']));

    const onSuccess = useCombinedHandler([onSuccessProp, onClosePopup]);

    return (
        <ManagedPopup
            title={t('title', [firstName])}
            isModal
            onOverlayClick={null}
            onClose={onClose}
            classNames={{
                inner: style.inner
            }}
        >
            <Suspense fallback="">
                <I18n className={style.info} t={t} tKey="info" />

                <MarketingPreferences
                    tKeyPrefix="popup."
                    showTerms
                    isConfirmPopup
                    onSuccess={onSuccess}
                    classNames={{
                        button: style.button,
                        form: style.form,
                        inner: style.inner
                    }}
                />
            </Suspense>
        </ManagedPopup>
    );
};
